import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { MODULE_IDS } from "../../constants/enums";
import {
  APP_FILE_CUSTOMER_OVERVIEW,
  APP_FILE_CUSTOMERS_LIST,
} from "./Customers.constants";

const CustomersList = Loadable(
  lazy(() =>
    import("./CustomerTabs").then(({ CustomersTabs }) => ({
      default: CustomersTabs,
    }))
  )
);


const CustomerOverview = Loadable(
  lazy(() =>
    import("./components/CustomerOverview/CustomerOverview").then(
      ({ CustomerOverview }) => ({
        default: CustomerOverview,
      })
    )
  )
);

export const CustomersRoutes = [
  {
    path: `${APP_FILE_CUSTOMERS_LIST}/`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.CUSTOMER]}>
        <CustomersList />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${APP_FILE_CUSTOMER_OVERVIEW}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.CUSTOMER]}>
        <CustomerOverview />
      </AuthorizedRoute>
    ),
  },
 
  
  
];
